export default {
  name: "Contact",
  data: () => ({
  }),
  components: {},
  mounted() {},
  methods: {},
};
